<template lang="html">
  <v-dialog
    v-model="dialog"
    max-width="350px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="role.name === 'SUPERADMIN'"   
        small    
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Role"
      text="Edit Role Details"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                outline
                label="Role Name"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="level"
                v-validate="'required|min_value:2|max_value:255'"
                :error-messages="errors.collect('level')"
                data-vv-name="level"
                type="number"
                label="Role Level"
                outline
              />
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="setDialog(false)"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"
            class="white--text px-10"
            @click="submitForm"
          >
            Update
          </v-btn>
        </v-card-actions>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      role: {
        type: Object,
        required: true,
      },
    },  
    data () {
      return {
        dialog: false,
        progressing: false,
        name: '',
        level: 0,
      }
    },
    watch: {
      dialog: function (status) {
        if (status) {
          this.name = this.role.name
          this.level = this.role.level
        }
      },
    },
    methods: {
      setProgressing (value = false) {
        this.progressing = value
      },
      setDialog (status) {
        this.dialog = status
      },
      prepareFormData () {
        let data = {}

        if (this.name !== this.role.name) {
          data.name = this.name
        }
        data.level = this.level

        return data
      },
      validateForm () {
        return this.$validator.validateAll()
      },
      submitForm () {
        this.validateForm().then((result) => {
          if (!result) return

          this.setProgressing(true)

          this.$api.hrisRoles().update(this.role.id, this.prepareFormData())
            .then((res) => {
              if (res.status >= 200 && res.status < 300) {             
                this.$emit('updated')
                this.$snack({ message: 'The HRIS role is updated successfully' })

                this.setDialog(false)
              }
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        })
      },
    },
  }
</script>
